import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SystemService {
  constructor(private httpService: HttpService) { }

  //#region AllocationType
  getAllocationTypes(params: any): Observable<any[]> {
    return this.httpService.get("system/allocation-types", { params })
  }

  addOrUpdateAllocationType(payload: any) {
    return this.httpService.post('system/allocation-types', payload);
  }
  //#endregion

  //#region DataProvider
  getDataProviders(params: any): Observable<any[]> {
    return this.httpService.get("system/data-providers", { params })
  }

  addOrUpdateDataProvider(payload: any) {
    return this.httpService.post('system/data-providers', payload);
  }
  //#endregion

  //#region DatasetType
  getDatasetTypes(params: any): Observable<any[]> {
    return this.httpService.get("system/dataset-types", { params })
  }

  addOrUpdateDatasetType(payload: any) {
    return this.httpService.post('system/dataset-types', payload);
  }
  //#endregion

  //#region DatasetUnit
  getDatasetUnits(params: any): Observable<any[]> {
    return this.httpService.get("system/dataset-units", { params })
  }

  addOrUpdateDatasetUnit(payload: any) {
    return this.httpService.post('system/dataset-units', payload);
  }
  //#endregion

  //#region DataSource
  getDataSources(params: any): Observable<any[]> {
    return this.httpService.get("system/data-sources", { params })
  }

  addOrUpdateDataSource(payload: any) {
    return this.httpService.post('system/data-sources', payload);
  }
  //#endregion
}
